// src/store/paginationSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  page: 1,
  pageSize: 15, // Global fallback, kept for backward compatibility
  topicPages: {}, // Store page numbers by topicId
  topicPageSizes: {}, // Store pageSize by topicId
};

const paginationSlice = createSlice({
  name: "pagination",
  initialState,
  reducers: {
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },
    resetPagination: (state) => {
      state.page = initialState.page;
      state.pageSize = initialState.pageSize;
      // Also reset topic pages and pageSizes
      state.topicPages = initialState.topicPages;
      state.topicPageSizes = initialState.topicPageSizes;
    },
    setTopicPage: (state, action) => {
      const { topicId, page } = action.payload;
      if (!topicId) return; // Don't update if topicId is missing

      // Initialize topicPages if it doesn't exist
      if (!state.topicPages) {
        state.topicPages = {};
      }

      // Store page number by topicId
      state.topicPages = {
        ...state.topicPages,
        [topicId]: page,
      };
    },
    setTopicPageSize: (state, action) => {
      const { topicId, pageSize } = action.payload;
      if (!topicId) return; // Don't update if topicId is missing

      // Initialize topicPageSizes if it doesn't exist
      if (!state.topicPageSizes) {
        state.topicPageSizes = {};
      }

      // Store pageSize by topicId
      state.topicPageSizes = {
        ...state.topicPageSizes,
        [topicId]: pageSize,
      };
    },
  },
});

export const { setPage, setPageSize, resetPagination, setTopicPage, setTopicPageSize } =
  paginationSlice.actions;

export default paginationSlice.reducer;
